import React, { useState, useEffect, useContext, useRef, useLayoutEffect } from "react"
import get from "lodash/get"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Section from "../components/section/section.component"
import PageLayout from "../layouts/page/page.layout"
import { Seo } from "../components/seo"
import Grid from "../components/grid/grid.component"
import Div from "../components/div/div.component"
import { Link } from "gatsby"
import DiscordConversation from "../components/discord-conversation/discord-conversation.component"
import InlineTestimonial from "../components/inline-testimonial/inline-testimonial.component"
import dataLayerHelper from "../helpers/datalayer.helper"
import ComparisonCard from "../components/comparison-card/comparison-card.component"
import {
  RiskFreeContainer,
  RiskFreeTextContainer,
  RiskFreeIcon,
  InlineHeader,
} from "../page-styles/academy.styles"

import { DuckArrow, DuckIcon, DuckIconText, DuckContainer } from "../components/nav-dropdown-link/nav-dropdown-link.styles-1"

import MobileContext from "../providers/mobile/mobile.provider"
import Arrow from "../svg/chevron-up-no-fill.svg"
import VideoIcon from "../svg/Video.svg"
import PageHeroStrapline from "../components/page-hero-strapline/page-hero-strapline.component"
import FromTheFounder from "../components/from-the-founder/from-the-founder.component"
import CompanyBar from "../components/company-logo-bar/company-logo-bar.component"
import { UpskillCard } from "../components/build-with-ai-ctas/upskill-card"
import { CareerPathButton } from "../components/career-path-buttons/career-path-button.component"

import {
  TopSectionContainer,
  CarouselAndButtonContainer,
  TextContainer,
  Subtitle,
  Title,
  BodyText,
  ImageContainer,
  DiscordImageContainer,
  InstructorImageContainer,
  LinkContainer,
  StatsBarContainer,
  StatsContainer,
  InstructorNameContainer,
  SectionHeader,
  MainTextSection,
  CarouselSection,
  CarouselOverlay,
  SlideTrack,
  ResponsiveSlide,
  MobileSlide,
  Slide,
  ButtonContainer,
  CarouselButtonInnerContainer,
  CarouselButton,
  ComparisonContainer,
  ComparisonSection,
  BenefitsSectionContainer,
  BenefitsCTALink,
  BenefitsSectionCardContainer,
  BenefitsFloatingCardContainer,
  BenefitsFloatingCardContentContainer,
  BenefitsFloatingCardInnerCardContainer,
  BenefitsFloatingCardHeading,
  BenefitsFloatingCardList,
  BenefitsFloatingCardInnerCardTitle,
  BenefitsFloatingCardInnerCardBody,
  BenefitsSectionHeaderContainer,
  BenefitsInlineHeader,
  CareerPathButtonsArea,
  CareerPathButtonsContainer,
  CareerPathSatelliteImage,
  VideoSatelliteImage,
  ProjectsSatelliteImage,
  CommunitySatelliteImage,
  CareerPathCTAsSection,
  CareerPathCTAsIntroTextContainer,
  CareerPathCTAsSectionHeader,
  CareerPathCTAsContainer,
  HomePageDuckContainer
} from "../page-styles/index.styles"

import WhosZtmFor from "../components/whos-ztm-for/whos-ztm-for.component"

// below for the testimoniall slide
import { TestimonialSlidesContainer } from "../page-styles/reviews.styles"
import SlideCTA from "../components/testimonial-slide/testimonial-slideCTA.component"
import TestimonalSlide from "../components/testimonial-slide/testimonial-slide.component"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import ButtonGroup from "../components/testimonial-slide/testimonial-button.component"
import { responsive } from "../components/testimonial-slide/config"
import TrustPilot from "../components/trust-pilot/trust-pilot.component"
import { background, backgroundColor } from "styled-system"
// above for testimonial slide

export const Head = ({ location, data }) => {
  return (
    <Seo
      metaData={data.allContentfulPageMeta.nodes[0]}
      uri={location.pathname}
    />
  )
}

gsap.registerPlugin(ScrollTrigger)

const InlinePage = (props) => {
  const metaData = get(props, "data.allContentfulPageMeta.nodes")[0]
  const indexData = get(props, "data.allContentfulNewHomePage.edges")[0].node

  const {
    testimonialCtaImage,
    testimonialSection,
    comparisonZtm,
    comparisonOtherPlatforms,
    comparisonBootCamps,
    careerPathButtonHeader,
    careerPathButtons,
    evenIfListDetail,
    evenIfSectionDetail,
    whoIsZtmForMainTitle,
    whoIsZtmForLeftTitle,
    whoIsZtmForRightTitle,
    ztmForLeft,
    ztmForRight,
  } = indexData

  const [activeSlide, setActiveSlide] = useState(0)
  const [userInteracted, setUserInteracted] = useState(false)
  const [autoPlay, setAutoPlay] = useState(true);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const minSwipeDistance = 50; // Minimum distance for a swipe to be registered

  const ztmData = comparisonZtm.childMarkdownRemark.html
  const otherPlatforms = comparisonOtherPlatforms.childMarkdownRemark.html
  const bootcamps = comparisonBootCamps.childMarkdownRemark.html
  const comparisonData = [otherPlatforms, ztmData, bootcamps]
  const careerPathDesktopImg = props.data.careerPathDesktop.nodes[0]
  const videoTutorialsDesktopImg = props.data.videoTutorialsDesktop.nodes[0]
  const projectsDesktopImg = props.data.projectsDesktop.nodes[0]
  const communityDesktopImg = props.data.communityDesktop.nodes[0]
  const slides = [careerPathDesktopImg, videoTutorialsDesktopImg, projectsDesktopImg, communityDesktopImg]
  const careerPathResponsivev2 = props.data.careerPathResponsivev2.nodes[0]
  const videoTutorialResponsive = props.data.videoTutorialResponsive.nodes[0]
  const projectsResponsive = props.data.projectsResponsive.nodes[0]
  const communityResponsive = props.data.communityResponsive.nodes[0]
  const responsiveSlides = [careerPathResponsivev2, videoTutorialResponsive, projectsResponsive, communityResponsive]
  const careerPathMobilev2 = props.data.careerPathMobilev2.nodes[0]
  const videoMobile = props.data.videoMobile.nodes[0]
  const projectsMobile = props.data.projectsMobile.nodes[0]
  const communityMobile = props.data.communityMobile.nodes[0]
  const mobileSlides = [careerPathMobilev2, videoMobile, projectsMobile, communityMobile]

  const totalSlides = 4

  const imgData = props.data
  const AIMLEngineerImg = imgData.AIMLEngineerImg.nodes[0].gatsbyImageData
  const FullStackDevImg = imgData.FullStackDevImg.nodes[0].gatsbyImageData
  const AIDevImg = imgData.AIDevImg.nodes[0].gatsbyImageData
  const DataEngineerImg = imgData.DataEngineerImg.nodes[0].gatsbyImageData
  const EthicalHackerImg = imgData.EthicalHackerImg.nodes[0].gatsbyImageData
  const DevOpsImg = imgData.DevOpsImg.nodes[0].gatsbyImageData

  useEffect(() => {
    if (!autoPlay) return;

    let interval;

    // Start the interval after a 2-second delay
    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        setActiveSlide((prev) => {
          if (prev === totalSlides - 1) {
            setAutoPlay(false);
            return prev;
          }
          return prev + 1;
        });
      }, 6000);
    }, 4000);

    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [autoPlay]);

  const handleUserSelect = (index) => {
    setAutoPlay(false)
    setActiveSlide(index)
  }

  // Student Avatars
  const justinLin = props.data.justinLin.nodes[0]
  const olgaFomin = props.data.olgaFomin.nodes[0]
  const dajana = props.data.dajana.nodes[0]
  const studentAvatars = [justinLin, olgaFomin, dajana]

  // Intro Copy
  const shortIntro = props.data.allContentfulNewHomePage.edges[0].node.shortIntro.childMarkdownRemark.html
  const pageHeader = props.data.allContentfulNewHomePage.edges[0].node.pageHeader.childMarkdownRemark.html

  const careerPathCTAsHeader = props.data.allContentfulNewHomePage.edges[0].node.careerPathHeader
  const careerPathCTAsText = props.data.allContentfulNewHomePage.edges[0].node.careerPathSectionDescription


  const { isStatic } = useContext(MobileContext)

  const totalCPs = get(props, "data.contentfulCareerPathListingPage").careerPathCardsOrder.length
  const courses = get(props, "data.allContentfulCourseCard.edges")

  const courseStats = courses.reduce(
    (acc, course) => {
      const { totalLessons, totalHours } = course.node
      acc.lessons = acc.lessons + totalLessons
      acc.hours = acc.hours + totalHours
      acc.courses++
      return acc
    },
    {
      lessons: 0,
      hours: 0,
      courses: 0,
    }
  )

  const [a, b, c] = indexData.featureTestimonial
  const [f1, f2, f3] = Object.values(indexData.featureDetails)
  const stats = {
    courses: {
      num: courseStats.courses,
      text: "courses",
      startNum: courseStats.courses - 5,
    },
    careerPaths: {
      num: totalCPs,
      text: "career paths",
      startNum: totalCPs - 5,
    },
    videoHours: {
      num: courseStats.hours.toFixed(0),
      text: "video hours",
      startNum: courseStats.hours.toFixed(0) - 5,
    },
  }

  const instructors = indexData.instructorInfo
  const newCommunityAssets = indexData.newCommunityAssets
  const handleClick = (text) => {
    dataLayerHelper({
      event: "homePageTextLinks",
      action: "Text Link Click",
      label: text,
    })
  }

  const BenefitsSectionCardContainerRef = useRef()

  useLayoutEffect(() => {
    ScrollTrigger.matchMedia({
      "(min-width: 1000px)": function () {
        gsap.to(BenefitsSectionCardContainerRef.current, {
          y: -80,
          duration: 1.5,
          scrollTrigger: {
            trigger: BenefitsSectionCardContainerRef.current,
          },
        })
      },
    })
  }, [])

  useEffect(() => {
    ScrollTrigger.matchMedia({
      "(min-width: 1080px)": function () {
        ScrollTrigger.create({
          trigger: ".compare-section",
          start: "top top",
          end: "bottom bottom",
          //markers: true,
          once: true,
          animation: gsap.from(".ztm-card", {
            y: 60,
            duration: 0.5,
          }),
        })
        return () => {
          gsap.set(".ztm-card", {
            y: 0,
          })
        }
      },
      "(min-width: 1000px)": function () {
        ScrollTrigger.batch(".img", {
          onEnter: (elements) => {
            elements.forEach((ele) => {
              gsap.fromTo(
                ele,
                {
                  bottom: 50,
                },
                {
                  bottom: 230,
                  ease: "none",
                  scrollTrigger: {
                    start: "top top",
                    end: "20%",
                    scrub: 0.4,
                    invalidateOnRefresh: false,
                  },
                }
              )
            })
          },
          //markers: true,
        })

        ScrollTrigger.batch(".counter", {
          start: "top-=750px",
          scrub: false,
          once: true,
          end: "bottom bottom",
          //markers: true,
          onEnter: (batches) => {
            batches.forEach((batch) => {
              const targetValue = stats[batch.id].num
              gsap.to(batch, {
                duration: 0.55,
                innerText: targetValue,
                snap: { innerText: 1 },
                onUpdate: function () {
                  batch.innerText = Math.floor(
                    this.targets()[0].innerText
                  ).toLocaleString() // Format with commas
                },
              })
            })
          },
        })

        ScrollTrigger.create({
          trigger: ".instructor-animate",
          start: "-=460",
          end: "bottom bottom",
          //markers: true,
          once: true,
          animation: gsap.from(".instructor", {
            y: 60,
            opacity: 0,
            duration: 1,
          }),
        })
      },
      "(max-width: 999px)": function () {
        document.querySelectorAll(".counter").forEach((counter) => {
          const targetValue = stats[counter.id]?.num || 0 // Ensure it's a valid number
          counter.innerText = `${Number(targetValue).toLocaleString()}` // Format with commas
        })

        document
          .querySelectorAll(".instructor")
          .forEach((instructor) => (instructor.style.opacity = 1))
      },
    })
  },
    // eslint-disable-next-line
    [])

  const renderLink = (textURL, text) => {
    if (textURL.includes("/")) {
      return (
        <LinkContainer href={textURL} mb={10} onClick={() => handleClick(text)}>
          {text}
          <Arrow
            style={{
              transform: "rotateZ(90deg)",
              marginLeft: "7px",
            }}
          />
        </LinkContainer>
      )
    } else {
      return (
        <LinkContainer
          href={`https://www.youtube.com/watch?v=${textURL}`}
          target="_blank"
        >
          <VideoIcon style={{ marginRight: "15px" }} />
          {text}
        </LinkContainer>
      )
    }
  }

  const handleTouchStart = (e) => {
    setTouchEndX(null) // Reset touch end position
    setTouchStartX(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return
    const distance = touchStartX - touchEndX
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance

    if (isLeftSwipe || isRightSwipe) {
      setUserInteracted(true)
      setAutoPlay(false)
      if (isLeftSwipe) {
        setActiveSlide((prev) => (prev === totalSlides - 1 ? prev : prev + 1))
      } else {
        setActiveSlide((prev) => (prev === 0 ? prev : prev - 1))
      }
    }
    // Reset touch positions
    setTouchStartX(null)
    setTouchEndX(null)
  }

  const handleSlideClick = (slideIndex) => {
    setUserInteracted(true);
    setAutoPlay(false); // Disable autoplay after user interaction
    setActiveSlide(slideIndex);
  };

  useEffect(() => {
    let resizeTimeout;
    let hasResized = false;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      setAutoPlay(false);
      hasResized = true;

      resizeTimeout = setTimeout(() => {
        if (!userInteracted && !hasResized) {
          setAutoPlay(true);
        }
      }, 1000);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(resizeTimeout)
      window.removeEventListener("resize", handleResize)
    }
  }, [userInteracted])

  return (
    <>
    <PageLayout mt={[0, 0, 0, 0, 0]}
      style={{
        overflow: "hidden",
      }}
    >
      <TopSectionContainer>
        <MainTextSection>
          <PageHeroStrapline
            studentAvatars={studentAvatars}
            topCopy={shortIntro}
            pageHeader={pageHeader}
            data={metaData.homePageIntroText}
            location={"Top"}
          />
        </MainTextSection>
        <CarouselAndButtonContainer>
          <CarouselSection>
            <CarouselOverlay>
              <>
                {/* Slide Track */}
                <SlideTrack
                  activeSlide={activeSlide}
                  slideCount={slides.length}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                >
                  {slides.map((slide, index) => (
                    <Slide key={index} index={index} isActive={index === activeSlide} >
                      <GatsbyImage
                        image={slide.gatsbyImageData}
                        alt={slide.description}
                      />
                      {index === 0 && (
                        <>
                          <CareerPathSatelliteImage image={props.data.careerPathDesktopPathway.nodes[0].gatsbyImageData} className="satellite-1" alt="career path pathway" />
                          <CareerPathSatelliteImage image={props.data.careerPathDesktopRocket.nodes[0].gatsbyImageData} className="satellite-2" alt="rocket icon" />
                          <CareerPathSatelliteImage image={props.data.careerPathDesktopTestimonialv2.nodes[0].gatsbyImageData} className="satellite-3" alt="testimonial" />
                        </>
                      )}
                      {index === 1 && (
                        <>
                          <VideoSatelliteImage image={props.data.videoTutorialsDesktopLabel.nodes[0].gatsbyImageData} className="satellite-1" alt="always up to date" />
                          <VideoSatelliteImage image={props.data.videoTutorialsDesktopVideo.nodes[0].gatsbyImageData} className="satellite-2" alt="video" />
                          <VideoSatelliteImage image={props.data.videoTutorialsDesktopTestimonial.nodes[0].gatsbyImageData} className="satellite-3" alt="testimonial" />
                        </>
                      )}
                      {index === 2 && (
                        <>
                          <ProjectsSatelliteImage image={props.data.projectsDesktopFire.nodes[0].gatsbyImageData} className="satellite-1" alt="fire icon" />
                          <ProjectsSatelliteImage image={props.data.projectsDesktopTestimonial.nodes[0].gatsbyImageData} className="satellite-2" alt="testimonial" />
                        </>
                      )}
                      {index === 3 && (
                        <>
                          <CommunitySatelliteImage image={props.data.communityDesktopDiscord.nodes[0].gatsbyImageData} className="satellite-1" alt="Discord icon" />
                          <CommunitySatelliteImage image={props.data.communityDesktopBell.nodes[0].gatsbyImageData} className="satellite-2" alt="bell icon" />
                          <CommunitySatelliteImage image={props.data.communityDesktopTestimonial.nodes[0].gatsbyImageData} className="satellite-3" alt="testimonial" isActive={index === activeSlide} />
                        </>
                      )}
                    </Slide>
                  ))}
                  {responsiveSlides.map((slide, index) => (
                    <ResponsiveSlide key={index} isActive={index === activeSlide}>
                      <GatsbyImage
                        image={slide.gatsbyImageData}
                        alt={slide.description}
                      />
                    </ResponsiveSlide>
                  ))}
                  {mobileSlides.map((slide, index) => (
                    <MobileSlide key={index} isActive={index === activeSlide}>
                      <GatsbyImage
                        image={slide.gatsbyImageData}
                        alt={slide.description}
                      />
                    </MobileSlide>
                  ))}
                </SlideTrack>
              </>
            </CarouselOverlay>
          </CarouselSection>
          {/* Navigation Buttons */}
          <ButtonContainer>
            {slides.map((_, index) => (
              <CarouselButtonInnerContainer
                onClick={() => {
                  handleUserSelect(index)
                  setActiveSlide(index)
                  handleSlideClick(index)
                }}
              >
                <CarouselButton
                  key={index}
                  index={index}
                  activeSlide={activeSlide}
                  isActive={activeSlide === index}
                  onClick={() => {
                    handleUserSelect(index)
                    setActiveSlide(index)
                    handleSlideClick(index)
                  }}
                >
                </CarouselButton>
              </CarouselButtonInnerContainer>
            ))}
          </ButtonContainer>
        </CarouselAndButtonContainer>
      </TopSectionContainer>
      <div className="full-bleed" style={{ background: "linear-gradient(to bottom, white 0%, rgb(241, 241, 246) 100%)" }}>
        <CompanyBar
          title={metaData.companyBarTitle}
          images={metaData.companyBarImages}
          desktopSpeed={metaData.companyBarDesktopSpeed}
          mobileSpeed={metaData.companyBarMobileSpeed}
          backgroundColor={metaData.companyBarBackgroundColor}
          titleColor={metaData.companyBarTitleColor}
          hasBackground={false}
        />
      </div>
      <BenefitsSectionContainer>
        <BenefitsSectionHeaderContainer>
          <BenefitsInlineHeader
            mt={[60, 60, 120, 120]}
            mb={[40, 40, 60, 60]}
          >
            {careerPathButtonHeader.whiteHeading}{" "}
            <span>{careerPathButtonHeader.blueHeading}</span>
          </BenefitsInlineHeader>
          </BenefitsSectionHeaderContainer>
          <CareerPathButtonsArea>
          <CareerPathButtonsContainer>
          {careerPathButtons.map((button, index) => {
            const { icon, iconHover, title, link } = button
            return (
              <CareerPathButton
                svg={`${icon}`}
                svgHover={`${iconHover}`}
                title={title}
                link={link}
                key={index}
              />
            )
          })}
        </CareerPathButtonsContainer>
        </CareerPathButtonsArea>
      </BenefitsSectionContainer>
       
      <BenefitsSectionCardContainer className="full-bleed">
        <BenefitsFloatingCardContainer ref={BenefitsSectionCardContainerRef}>
          <BenefitsFloatingCardContentContainer>
            <BenefitsFloatingCardHeading>
              {" "}
              {evenIfSectionDetail.heading}
              <span> {evenIfSectionDetail.blueheading}</span>
            </BenefitsFloatingCardHeading>
            <BenefitsFloatingCardList
              dangerouslySetInnerHTML={{
                __html: evenIfListDetail.childMarkdownRemark.html,
              }}
            />
          </BenefitsFloatingCardContentContainer>
          <BenefitsFloatingCardInnerCardContainer>
            <BenefitsFloatingCardInnerCardTitle>
              {" "}
              {evenIfSectionDetail.CTA_title}{" "}
            </BenefitsFloatingCardInnerCardTitle>
            <BenefitsFloatingCardInnerCardBody
              dangerouslySetInnerHTML={{
                __html: evenIfSectionDetail.CTA_desc,
              }}
            />

            <BenefitsCTALink
              ghostSecondary
              internal
              url={evenIfSectionDetail.CTA_button_url}
              onClick={() =>
                dataLayerHelper({
                  event: "ZTMBenfitCTAButtonClick",
                  label: evenIfSectionDetail.CTA_button_text,
                })
              }
            >
              {evenIfSectionDetail.CTA_button_text}
            </BenefitsCTALink>
          </BenefitsFloatingCardInnerCardContainer>
        </BenefitsFloatingCardContainer>
      </BenefitsSectionCardContainer>
      
       {/* NEW CAREER PATH CTAs */}
       <CareerPathCTAsSection className="full-bleed">
   
        <Grid style={{margin: "0 auto"}}>
          <CareerPathCTAsSectionHeader mb={[15, 15, 25, 25]}>
            {careerPathCTAsHeader}
          </CareerPathCTAsSectionHeader>
          <CareerPathCTAsIntroTextContainer dangerouslySetInnerHTML={{ __html: careerPathCTAsText.childMarkdownRemark.html }} />
         </Grid>

        <CareerPathCTAsContainer>
          <Link
            style={{ textDecoration: "none" }}
            to={`/career-paths/become-a-machine-learning-engineer/`}>
            <UpskillCard
              image={AIMLEngineerImg}
              bgColor="#FFFFFF"
              textColor="#000000"
              headerColor="#4C0FFB"
              defaultArrow="blue"
              hoverArrow="white"
              arrowBgColor="white"
              arrowBgHoverColor="#4C0FFB"
              arrowBorderColor="#4C0FFB"
              arrowBorderHoverColor="#4C0FFB"
              careerPathHeader="Become an"
              header="AI & Machine Learning Engineer"
              style={{maxHeight: "220px"}}
            />
          </Link>
          <Link
            style={{ textDecoration: "none" }}
            to={`/career-paths/become-a-web-developer/`}>
            <UpskillCard
              image={FullStackDevImg}
              bgColor="#FFFFFF"
              textColor="#000000"
              headerColor="#4C0FFB"
              defaultArrow="blue"
              hoverArrow="white"
              arrowBgColor="white"
              arrowBgHoverColor="#4C0FFB"
              arrowBorderColor="#4C0FFB"
              arrowBorderHoverColor="#4C0FFB"
              careerPathHeader="Become a"
              header="Fullstack Web Developer"
              style={{maxHeight: "220px"}}
            />
          </Link>
          <Link
            style={{ textDecoration: "none" }}
            to={`/career-paths/become-an-ai-developer/`}>
            <UpskillCard
              image={AIDevImg}
              bgColor="#FFFFFF"
              textColor="#000000"
              headerColor="#4C0FFB"
              defaultArrow="blue"
              hoverArrow="white"
              arrowBgColor="white"
              arrowBgHoverColor="#4C0FFB"
              arrowBorderColor="#4C0FFB"
              arrowBorderHoverColor="#4C0FFB"
              careerPathHeader="Become an"
              header="AI Developer"
            />
           </Link> 
            <Link
            style={{ textDecoration: "none" }}
            to={`/career-paths/become-a-data-engineer/`}>
            <UpskillCard
              image={DataEngineerImg}
              bgColor="#FFFFFF"
              textColor="#000000"
              headerColor="#4C0FFB"
              defaultArrow="blue"
              hoverArrow="white"
              arrowBgColor="white"
              arrowBgHoverColor="#4C0FFB"
              arrowBorderColor="#4C0FFB"
              arrowBorderHoverColor="#4C0FFB"
              careerPathHeader="Become a"
              header="Data Engineer"
            />
          </Link>
          <Link
            style={{ textDecoration: "none" }}
            to={`/career-paths/become-an-ethical-hacker/`}>
            <UpskillCard
              image={EthicalHackerImg}
              bgColor="#FFFFFF"
              textColor="#000000"
              headerColor="#4C0FFB"
              defaultArrow="blue"
              hoverArrow="white"
              arrowBgColor="white"
              arrowBgHoverColor="#4C0FFB"
              arrowBorderColor="#4C0FFB"
              arrowBorderHoverColor="#4C0FFB"
              careerPathHeader="Become a"
              header="Cybersecurity Expert"
            />
          </Link>
           <Link
            style={{ textDecoration: "none" }}
            to={`/career-paths/become-a-devops-engineer/`}>
            <UpskillCard
              image={DevOpsImg}
              bgColor="#FFFFFF"
              textColor="#000000"
              headerColor="#4C0FFB"
              defaultArrow="blue"
              hoverArrow="white"
              arrowBgColor="white"
              arrowBgHoverColor="#4C0FFB"
              arrowBorderColor="#4C0FFB"
              arrowBorderHoverColor="#4C0FFB"
              careerPathHeader="Become a"
              header="DevOps Engineer"
            />
          </Link>
          
      </CareerPathCTAsContainer>
      <HomePageDuckContainer>
      <DuckContainer homepage={true} to="/tech-career-path-quiz/"><DuckIcon /><DuckIconText>Not sure where to start?<br className="mobile-break" /> <strong>Take our career quiz</strong></DuckIconText><DuckArrow /></DuckContainer>
      </HomePageDuckContainer>
      </CareerPathCTAsSection>
      {/* OUR ACADEMY */}
      <Div mt={[20, 20, 100, 100]} id="counter-trigger">
        <Grid>
          <SectionHeader mb={[40, 40, 80, 80]}>
            {indexData.featureSectionTitle}
          </SectionHeader>

          <TextContainer>
            <Subtitle>{f1.subtitle}</Subtitle>
            <Div mb={[15, 15, 25, 25]}>
              <Title>{f1.title}</Title>
              <BodyText>{f1.desc}</BodyText>
              {f1.links.map(({ textURL, text }) => renderLink(textURL, text))}
            </Div>

            <InlineTestimonial key={a.id} avatarImage={a.avatarImage} {...a} />
          </TextContainer>

          <ImageContainer>
            <GatsbyImage
              image={indexData.academyImage.gatsbyImageData}
              alt="academy image"
              loading="lazy"
            />
            <StatsBarContainer mt={10}>
              {
                Object.keys(stats).map((key) => {
                  return (
                    <StatsContainer key={key}>
                      <span className="counter" id={key}>{stats[key].startNum}</span>
                      <h6>{stats[key].text}</h6>
                    </StatsContainer>
                  )
                })
              }
            </StatsBarContainer>
          </ImageContainer>
        </Grid>
      </Div>
      {/* Our Community */}
      <Div my={[60, 60, 60, 60]}>
        <Grid>
          <DiscordImageContainer>
            {isStatic ? (
              <img
                src={`${newCommunityAssets[3].file.url}?w=700&fm=webp`}
                alt={newCommunityAssets[3].title}
                loading="lazy"
              />
            ) : (
              <DiscordConversation
                mt={[40, 40, 40, 0]}
                gridRow={[2, 2, 2, 1]}
                gridColumn={["1/-1", "1/-1", "1/-1", "1/7"]}
                newCommunityAssets={newCommunityAssets}
              />
            )}
          </DiscordImageContainer>
          <Div gridColumn={["1/-1", "1/-1", "1/-1", "8/13"]}>
            <Subtitle>{f2.subtitle}</Subtitle>
            <Div mb={[15, 15, 25, 25]}>
              <Title>{f2.title}</Title>
              <BodyText>{f2.desc}</BodyText>

              {f2.links.map(({ textURL, text }) => {
                return renderLink(textURL, text)
              })}
            </Div>

            <InlineTestimonial key={b.id} avatarImage={b.avatarImage} {...b} />
          </Div>
        </Grid>
      </Div>
      {/* Our INSTRUCTOR */}

      <Div mb={[60, 60, 150, 150]} className="instructor-animate">
        <Grid>
          <Subtitle>{f3.subtitle}</Subtitle>
          <TextContainer>
            <Div mb={[15, 15, 25, 25]}>
              <Title>{f3.title}</Title>
              <BodyText>{f3.desc}</BodyText>
              {f3.links.map(({ textURL, text }) => renderLink(textURL, text))}
            </Div>

            <InlineTestimonial key={c.id} avatarImage={c.avatarImage} {...c} />
          </TextContainer>

          <InstructorImageContainer>
            {isStatic ? (
              <GatsbyImage
                image={indexData.fourInstructorsImages[1].gatsbyImageData}
                alt={indexData.fourInstructorsImages[1].title}
                loading="lazy"
              />
            ) : (
              <>
                <GatsbyImage
                  image={indexData.fourInstructorsImages[0].gatsbyImageData}
                  alt={indexData.fourInstructorsImages[0].title}
                  loading="lazy"
                />

                {instructors.map(({ name, title, direction }) => (
                  <InstructorNameContainer
                    direction={direction}
                    className="instructor"
                  >
                    <h4>{name}</h4>
                    <span> {title}</span>
                  </InstructorNameContainer>
                ))}
              </>
            )}
          </InstructorImageContainer>
        </Grid>
      </Div>
      <Section
        faqBackground
        pb={[60, 60, 80, 80]}
        pt={[60, 60, 120, 120]}
        style={{
          paddingLeft: "0",
          paddingRight: "0",
          overflowX: "hidden",
        }}
      >
        <TrustPilot
          title={testimonialSection.sectionTitle}
          desc={testimonialSection.sectionIntroText.childMarkdownRemark.html}
          hasStars={true}
        />
        <TestimonialSlidesContainer>
          <Carousel
            containerClass="carousel-slide"
            partialVisible={true}
            responsive={responsive}
            arrows={false}
            customTransition="transform 400ms ease-out"
            renderButtonGroupOutside={true}
            customButtonGroup={<ButtonGroup />}
          >
            {indexData.testimonialSection.testimonials.map(
              ({
                id,
                avatarImage,
                name,
                githubUrl,
                twitterUrl,
                linkedinUrl,
                mediumUrl,
                statement,
                company,
                jobTitle,
                videoLink,
                linkTextOverride,
              }) => (
                <TestimonalSlide
                  className="card"
                  key={id}
                  avatarImage={avatarImage}
                  name={name}
                  githubUrl={githubUrl}
                  twitterUrl={twitterUrl}
                  linkedinUrl={linkedinUrl}
                  mediumUrl={mediumUrl}
                  statement={statement}
                  company={company}
                  jobTitle={jobTitle}
                  videoLink={videoLink}
                  linkTextOverride={linkTextOverride}
                />
              )
            )}
            <SlideCTA
              ctaImg={testimonialCtaImage.gatsbyImageData}
              btnLink={testimonialSection.ctaButtonLink}
              ctaText={testimonialSection.seeMoreText.childMarkdownRemark.html}
            />
          </Carousel>
        </TestimonialSlidesContainer>
      </Section>
      <WhosZtmFor
        title={whoIsZtmForMainTitle}
        leftTitle={whoIsZtmForLeftTitle}
        leftBullets={ztmForLeft.childMarkdownRemark.html}
        rightTitle={whoIsZtmForRightTitle}
        rightBullets={ztmForRight.childMarkdownRemark.html}
      />
      <ComparisonSection
        className="compare-section"
        style={{ overflowX: "hidden" }}
      >
        <Grid>
          <InlineHeader mt={[60, 60, 120, 120]} mb={[40, 40, 70, 100]}>
            {indexData.comparisonSectionTitle}
          </InlineHeader>
          <ComparisonContainer>
            {comparisonData.map((data, index) => (
              <ComparisonCard
                key={index}
                order={index}
                data={data}
                priceData={indexData.priceData}
              />
            ))}
          </ComparisonContainer>
          <RiskFreeContainer mt={[40, 40, 70, 120]} mb={[60, 60, 120, 120]}>
            <RiskFreeIcon />
            <RiskFreeTextContainer>
              <span>100% RISK FREE</span>
              <p>{indexData.riskFreeStatement}</p>
            </RiskFreeTextContainer>
          </RiskFreeContainer>
        </Grid>
      </ComparisonSection>
      <FromTheFounder
        founderData={{
          title: indexData.andreisMessageTitle,
          message: indexData.andreisMessageDesc,
          image: indexData.andreisMessageImage,
          ctaText: indexData.andreisMessageCtaText,
          ctaLink: indexData.andreisMessageCtaLink,
          bioBtnText: indexData.andreisMessageBioButtonText,
          bioBtnLink: indexData.andreisMessageBioButtonLink,
        }}
        straplineData={metaData.revolvingStraplineHero}
      />
    </PageLayout>
    </>
  )
}

export default InlinePage

export const pageQuery = graphql`
  query InlineIndexQuery {
   AIMLEngineerImg: allContentfulAsset(
    filter: { contentful_id: { eq: "5I6ucCAiSCWaTKqruyiOfp" } }
    ) {
      nodes {
        gatsbyImageData(
        placeholder: BLURRED, 
        layout: CONSTRAINED,
        width: 200)
        description
      }  
    }
    FullStackDevImg: allContentfulAsset(
    filter: { contentful_id: { eq: "3zGQ1kIW05GKhvJUY4Qpbc" } }
    ) {
      nodes {
        gatsbyImageData(
        placeholder: BLURRED, 
        layout: CONSTRAINED,
        width: 200)
        description
      }  
    }
    DataEngineerImg: allContentfulAsset(
    filter: { contentful_id: { eq: "6whRS5ySXXBz36mQDxdqPf" } }
    ) {
      nodes {
        gatsbyImageData(
        placeholder: BLURRED, 
        layout: CONSTRAINED,
        width: 200)
        description
      }  
    }
      AIDevImg: allContentfulAsset(
    filter: { contentful_id: { eq: "7I3LulRK5Zsp0eJX4rRL2R" } }
    ) {
      nodes {
        gatsbyImageData(
        placeholder: BLURRED, 
        layout: CONSTRAINED,
        width: 200)
        description
      }  
    }
      EthicalHackerImg: allContentfulAsset(
    filter: { contentful_id: { eq: "6D0X8NWPKXQX7xYVQVMZbW" } }
    ) {
      nodes {
        gatsbyImageData(
        placeholder: BLURRED, 
        layout: CONSTRAINED,
        width: 200)
        description
      }  
    }
    DevOpsImg: allContentfulAsset(
    filter: { contentful_id: { eq: "58UjoshsGwNkEshH6KixQl" } }
    ) {
      nodes {
        gatsbyImageData(
        placeholder: BLURRED, 
        layout: CONSTRAINED,
        width: 200)
        description
      }  
    }
  careerPathDesktop: allContentfulAsset(
    filter: { contentful_id: { eq: "2eJIB3QGQLSMyzxOQdLd6Y" } }
  ) {
    nodes {
      gatsbyImageData(
      placeholder: BLURRED, 
      layout: CONSTRAINED,
      width: 525)
      description
    }  
  }
    careerPathDesktopPathway: allContentfulAsset(
    filter: { contentful_id: { eq: "4T6KRAW3gnV5SjmAjbftcU" } }
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 175)
    }  
  }
    careerPathDesktopRocket: allContentfulAsset(
    filter: { contentful_id: { eq: "1yFhrKT4qCujclkI9krP2B" } }
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 170)
    }  
  }
    careerPathDesktopTestimonialv2: allContentfulAsset(
    filter: { contentful_id: { eq: "7H9XIpooyi0GSKiDki42a" } }
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 475)
    }  
  }
  videoTutorialsDesktop: allContentfulAsset(
    filter: { contentful_id: { eq: "57WCPZmWk0zB7tFYmxNU56"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 525)
      description
    }  
  }
    videoTutorialsDesktopLabel: allContentfulAsset(
    filter: { contentful_id: { eq: "7DfyY0se0KiGkZRRKc8XCo"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 250)
    }  
  }
    videoTutorialsDesktopVideo: allContentfulAsset(
    filter: { contentful_id: { eq: "4gW5fi3VNgU6DQZeS6nNfN"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 300)
    }  
  }
    videoTutorialsDesktopTestimonial: allContentfulAsset(
    filter: { contentful_id: { eq: "2zG0XKaJ3TisWqiLIvsiJr"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 500)
    }  
  }
    projectsDesktop: allContentfulAsset(
    filter: { contentful_id: { eq: "2sWdOgKbzL1prbXGUPI6eR"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 525)
      description
    }  
  }
    projectsDesktopFire: allContentfulAsset(
    filter: { contentful_id: { eq: "5NmcXzAPQxVbDPJJx5SLkD"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 190)
    }  
  }
    projectsDesktopTestimonial: allContentfulAsset(
    filter: { contentful_id: { eq: "2zG03BZU5sYlWXl04F5067"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 500)
    }  
  }
    communityDesktop: allContentfulAsset(
    filter: { contentful_id: { eq: "3iSS2XlaXetPtSgdmE9RWp"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 525)
      description
    }  
  }
    communityDesktopDiscord: allContentfulAsset(
    filter: { contentful_id: { eq: "1xwFI00BrfnKOOUghnmJiV"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 165)
    }  
  }
    communityDesktopBell: allContentfulAsset(
    filter: { contentful_id: { eq: "2gZc9PiTdfGLN5yOmp14Ue"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 70)
    }  
  }
    communityDesktopTestimonial: allContentfulAsset(
    filter: { contentful_id: { eq: "1d8HtHyMvqWB3WSkIGgups"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 450)
    }  
  }
    careerPathResponsivev2: allContentfulAsset(
    filter: { contentful_id: {eq: "6CnORrYrCeYRFiga5Q6Su7"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 500)
      description
    }  
  }
    videoTutorialResponsive: allContentfulAsset(
    filter: { contentful_id: {eq: "4iOvRgLnO7fWbOCa9hyfiP"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 500)
      description
    }  
  }
    projectsResponsive: allContentfulAsset(
    filter: { contentful_id: {eq: "2kDXUHFkK2Q1RLopMOM8sK"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 500)
      description
    }  
  }
    communityResponsive: allContentfulAsset(
    filter: { contentful_id: {eq: "7bLlJ24dHUsqAkPKAJMkK4"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 500)
      description
    }  
  }
    careerPathMobilev2: allContentfulAsset(
    filter: { contentful_id: {eq: "1PBeTNTCxI762jYBLZPFTs"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 370)
      description
    }  
  }
    videoMobile: allContentfulAsset(
    filter: { contentful_id: {eq: "1eopxNdrYpsHqaO4Wg8ciP"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 370)
      description
    }  
  }
    projectsMobile: allContentfulAsset(
    filter: { contentful_id: {eq: "4ZQk8dP1WbAA6bs87bkmsf"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 370)
      description
    }  
  }
    communityMobile: allContentfulAsset(
    filter: { contentful_id: {eq: "4q2WbGTsWliDIJ0TxH34VN"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 370)
      description
    }  
  }
    justinLin: allContentfulAsset(
    filter: { contentful_id: {eq: "1hWqm6eCullt2g1imN8oqO"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 50)
    }  
  }
    olgaFomin: allContentfulAsset(
    filter: { contentful_id: {eq: "35nDaLLllaeOPwpgibMaz5"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 50)
    }  
  }
     dajana: allContentfulAsset(
    filter: { contentful_id: {eq: "7A9XvsC5paIbAQTA91gctB"}}
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED, width: 50)
    }  
  }
    allContentfulPageMeta(
      filter: { contentful_id: { eq: "107t1SVzQWSx9ibex3tQQm" } }
    ) {
      nodes {
        pageTitle
        pageRobots
        embedImage {
          file {
            url
          }
        }
        pageDescription
        alertBanner {
          enabled
          text {
            childMarkdownRemark {
              html
            }
          }
          isSticky
          bannerEndDate
          countdownEnabled
        }
        revolvingStraplineHero {
          title
          description
          straplines
          link_url
          link_text
          button_url
          button_text
        }
        homePageIntroText {
          bullets
          link_url
          link_text
          button_url
          button_text
        }
        companyBarTitle
        companyBarBackgroundColor
        companyBarTitleColor
        companyBarDesktopSpeed
        companyBarMobileSpeed
        companyBarImages {
          id
          title
          file {
            url
          }
        }
      }
    }
    allContentfulCourseCard {
      totalCount
      edges {
        node {
          ...courseCardInfo
        }
      }
    }
    allContentfulContentAuthor(
      filter: { isInstructor: { eq: true } }
    ) {
      totalCount
    }
    contentfulCareerPathListingPage(
      contentful_id: { eq: "Jyc9t5cKdfslQkXLPKVUS" }
    ) {
      careerPathCardsOrder {
        id
      }
    }
    allContentfulBonusContentCard(filter: { subtitleIcon: { eq: "youtube" } }) {
      totalCount
    }

    allContentfulNewHomePage(
      filter: { contentful_id: { eq: "44hM49xtKlC78VGg7oGOFf" } }
    ) {
      edges {
        node {
        careerPathHeader
          careerPathSectionDescription {
            childMarkdownRemark {
              html
            }
          }
          shortIntro {
            childMarkdownRemark {
              html
            }
          }
            pageHeader {
          childMarkdownRemark {
            html
          }
        }
          riskFreeStatement
          comparisonSectionTitle
          priceData {
            text
            price
          }
          comparisonZtm {
            childMarkdownRemark {
              html
            }
          }
          comparisonOtherPlatforms {
            childMarkdownRemark {
              html
            }
          }
          comparisonBootCamps {
            childMarkdownRemark {
              html
            }
          }
          evenIfListDetail {
            childMarkdownRemark {
              html
            }
          }
          whoIsZtmForMainTitle
          whoIsZtmForLeftTitle
          whoIsZtmForRightTitle
          ztmForLeft {
            childMarkdownRemark {
              html
            }
          }
          evenIfSectionDetail {
            CTA_desc
            CTA_title
            blueheading
            CTA_button_text
            CTA_button_url
            heading
          }
          ztmForRight {
            childMarkdownRemark {
              html
            }
          }
          andreisMessageTitle
          andreisMessageDesc {
            childMarkdownRemark {
              html
            }
          }
          andreisMessageImage {
            file {
              url
            }
          }
          andreisMessageBioButtonText
          andreisMessageBioButtonLink
          andreisMessageCtaText
          andreisMessageCtaLink
          careerPathButtonHeader {
            whiteHeading
            blueHeading
          }
          careerPathButtons {
            icon
            iconHover
            title
            link
          }  
          testimonialCtaImage {
            gatsbyImageData(placeholder: BLURRED, width: 600)
          }
          testimonialSection {
            sectionTitle
            sectionIntroText {
              childMarkdownRemark {
                html
              }
            }
            ctaButtonLink
            seeMoreTestimonials
            seeMoreText {
              childMarkdownRemark {
                html
              }
            }
            testimonials {
              id
              avatarImage {
                gatsbyImageData(placeholder: BLURRED, width: 100)
              }
              company {
                title
                gatsbyImageData(placeholder: BLURRED, width: 80)
                file {
                  url
                }
              }
              name
              hiredAt
              jobTitle
              videoLink
              githubUrl
              linkedinUrl
              mediumUrl
              twitterUrl
              statement
              linkTextOverride
            }
          }
          featureSectionTitle
          featureTestimonial {
            id
            name
            hiredAt
            githubUrl
            linkedinUrl
            twitterUrl
            mediumUrl
            statement
            inlineStatement {
              childMarkdownRemark {
                html
              }
            }
            link
            jobTitle
            avatarImage {
              gatsbyImageData(
                layout: FIXED
                width: 75
                height: 75
                placeholder: BLURRED
              )
            }
            company {
              title
              file {
                url
              }
            }
          }
          newCommunityAssets {
            title
            file {
              url
            }
          }
          academyImage {
            gatsbyImageData(placeholder: BLURRED)
          }
          fourInstructorsImages {
            title
            gatsbyImageData(placeholder: BLURRED)
          }
          instructorInfo {
            title
            name
            direction
          }
          featureDetails {
            sectA {
              desc
              subtitle
              links {
                text
                textURL
              }
              title
            }
            sectB {
              desc
              subtitle
              links {
                text
                textURL
              }
              title
            }
            sectC {
              desc
              subtitle
              links {
                text
                textURL
              }
              title
            }
          }
        }
      }
    }
  }
`
